module.exports = __webpack_public_path__ + "img/article_1_3.8d10407e.png";